export const isAuthenticated = (): boolean => {
    const accessToken = localStorage.getItem('accessToken')
    const refreshToken = localStorage.getItem('refreshToken')
    return !!accessToken && !!refreshToken
}
